{
  "version": 1,
  "asset_id": "b7024b42-20d7-4689-a184-690371e574b0",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/b7024b42-20d7-4689-a184-690371e574b0/hero-signing.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/b7024b42-20d7-4689-a184-690371e574b0/hero-signing.jpg",
  "original_filename": "hero-signing.jpg",
  "size": 126369,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:13Z"
}
